<template>
  <section class="works">
    <div class="works__content container">
      <h1 class="works__title --fade-in-up" data-vertical-ivp-class="--animate">HOW IT WORKS</h1>
      <div class="works__owl-carousel owl-carousel owl-theme" id="owl-carousel">
        <div class="works__card">
          <img src="../assets/howitworks/how1.png" alt=""/>
          <h1 class="works__card-title">Comprehensive Home and Environment Analysis</h1>
          <p class="works__card-description">It all starts with an analysis of your entire home
            by a trained environmental inspector. Homes often contain highly toxic material including mold,
            asbestos, and radon that must be removed to ensure a clean, safe living space.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how2.png" alt=""/>
          <h1 class="works__card-title">System Planning and Design</h1>
          <p class="works__card-description">A GeoSolarPlus project manager will assess site conditions including
            envelope insulation, existing HVAC equipment, ductwork or radiant floor loops, geothermal
            drilling sites, rooftop availability for solar installation, electrical infrastructure,
            and lighting systems. Energy usage and requirements will be reviewed to design the right-sized system for your home.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how3.png" alt=""/>
          <h1 class="works__card-title">Detoxification and Upgraded Insulation</h1>
          <p class="works__card-description">An energy efficient home must have a tight building envelope that minimizes
            air flow from the outside. Asbestos and other toxic materials that compromise indoor air quality
            will be removed from your home. Insulation and envelope will be upgraded to non-toxic materials and weather stripping.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how4.png" alt=""/>
          <h1 class="works__card-title">Geothermal Drilling Rig</h1>
          <p class="works__card-description">The heart of the GeoSolarPlus system is the geothermal ground-based energy
            from the earth under your home. A truck-mounted or modular sonic rig will drill 4-6” wells down 300-400
            feet and insert high-density polyethylene pipe ground loops that tap into the unlimited power source of the earth.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how5.png" alt=""/>
          <h1 class="works__card-title">Experienced Technologists Monitor Drilling</h1>
          <p class="works__card-description">An experienced drilling technician will monitor all drilling to ensure the wells
            are sited in the correct location and drilled to the appropriate depth. Drilling water will be recycled and
            reused and excavated material will be captured for easy removal. Once in place, the homeowner is never
            aware the drilling ever occurred. The system is expected to operate for 50 years.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how6.png" alt=""/>
          <h1 class="works__card-title">Ground Loops Tap into the Earth's Power Source</h1>
          <p class="works__card-description">The geothermal system is powered by ground loops that circulate non-toxic
            fluid to a high-volume heat/air pump. The heat pump and circulating fluid continuously transfer
            heat from the home into or out of the ground depending on the season. The system can be easily
            connected to existing air ducts or radiant flooring loops and provides all the home's heating,
            cooling, and hot water.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how7.png" alt=""/>
          <h1 class="works__card-title">ROOFTOP SOLAR PROVIDES CLEAN ELECTRICITY</h1>
          <p class="works__card-description">Our crew will install a state-of-the-art photovoltaic (PV) solar
            system on your roof, sized to provide all the electricity your home will ever need.
            Because of the reduced energy requirements due to new insulation, envelope, and geothermal
            energy, the number of panels required is reduced effectively dropping overall system costs.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how8.png" alt=""/>
          <h1 class="works__card-title">Electric Car Charger</h1>
          <p class="works__card-description">Each GeoSolarPlus System includes a new electric vehicle (EV)
            charging station that will be installed in your garage to power your car, saving you
            money while you help with the climate crisis.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how9.png" alt=""/>
          <h1 class="works__card-title">LED Lighting Upgrade</h1>
          <p class="works__card-description">As a part of the GeoSolarPlus energy upgrade, LED bulbs will
            be installed throughout your home. In addition to saving money, LEDs offer numerous advantages
            over incandescent and compact fluorescent bulbs: less heat, 10x longer life, 80% less energy usage,
            non-toxic, better lighting.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how10.png" alt=""/>
          <h1 class="works__card-title">Advanced Whole Home Air Purification</h1>
          <p class="works__card-description">The COVID-19 crisis has made it more important than ever to have clean,
            healthy air throughout your home. The GeoSolarPlus system includes a commercial-grade complete
            home air purification system that will ensure your family is breathing air that has been
            filtered and sanitized to hospital-grade standards.</p>
        </div>
        <div class="works__card">
          <img src="../assets/howitworks/how11.png" alt=""/>
          <h1 class="works__card-title">SMART HOME TECHNOLOGY AND ENERGY MONITORING</h1>
          <p class="works__card-description">Integrated energy controls with mobile connectivity for laptop and
            cellphone access provides a simple way to manage the system. Users can monitor the air movement
            and purity throughout their homes and view energy production and usage. Options exist to integrate
            whole-house lighting and security control systems.</p>
        </div>
      </div>
      <CTA />
    </div>
  </section>
</template>

<script>
const $ = require( 'jquery' );
import CTA from '../components/cta.vue';

export default {
  name: 'howitworks',
  components: {
    CTA
  },
  data () {
    return {
    }
  },
  mounted() {
    $(document).ready(function(){
      $('#owl-carousel').owlCarousel({
        items: 3,
        loop: true,
        dotsEach: true,
        dots: true,
        margin: 25,
        autoplay: true,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        responsiveClass:true,
        responsive:{
          0:{
            items:1,
          },
          600:{
            items:2,
          },
          1000:{
            items:3,
          }
        }
      });
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../styles/components/howitworks.scss";
</style>
